import { AclPermissionDetail } from '../models';

export const createAclPermissionDetail = ({
  allowed,
  detail,
}: {
  allowed: boolean;
  detail?: string;
}): AclPermissionDetail => ({ allowed, detail });
